define('OutSystems/ClientRuntime/LongInteger',["require", "exports", "long"], function (require, exports, LongJS) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LongJSCommonJs = require("long");
    var LongInteger = (function () {
        function LongInteger(low, high, unsigned) {
            this.neg = this.negate;
            this.eq = this.equals;
            this.lt = this.lessThan;
            this.lte = this.lessThanOrEqual;
            this.gt = this.greaterThan;
            this.gte = this.greaterThanOrEqual;
            this.internalValue = new LongJSCommonJs(low, high, unsigned);
        }
        LongInteger.fromNumber = function (value) {
            var newInstance = new LongInteger(0);
            newInstance.internalValue = LongJS.fromNumber(value);
            return newInstance;
        };
        LongInteger.fromString = function (value) {
            var newInstance = new LongInteger(0);
            newInstance.internalValue = LongJS.fromString(value);
            return newInstance;
        };
        LongInteger.fromValue = function (value) {
            var valueConverted = typeof value === "object" ? value.internalValue : value;
            var newInstance = new LongInteger(0);
            newInstance.internalValue = LongJS.fromValue(valueConverted);
            return newInstance;
        };
        LongInteger.fromObject = function (value) {
            var longjs = LongJS.fromValue(value);
            var newInstance = LongInteger.fromString(longjs.toString());
            return newInstance;
        };
        LongInteger.unwrapInputValue = function (value) {
            if (typeof value === "string" || typeof value === "number") {
                return value;
            }
            if ("internalValue" in value) {
                return value.internalValue;
            }
            return value;
        };
        LongInteger.prototype.negate = function () {
            var result = this.internalValue.negate();
            var newInstance = LongInteger.fromObject(result);
            return newInstance;
        };
        LongInteger.prototype.add = function (value) {
            var unwrappedValue = LongInteger.unwrapInputValue(value);
            var result = this.internalValue.add(unwrappedValue);
            var newInstance = LongInteger.fromObject(result);
            return newInstance;
        };
        LongInteger.prototype.sub = function (value) {
            var unwrappedValue = LongInteger.unwrapInputValue(value);
            var result = this.internalValue.sub(unwrappedValue);
            var newInstance = LongInteger.fromObject(result);
            return newInstance;
        };
        LongInteger.prototype.mul = function (value) {
            var unwrappedValue = LongInteger.unwrapInputValue(value);
            var result = this.internalValue.mul(unwrappedValue);
            var newInstance = LongInteger.fromObject(result);
            return newInstance;
        };
        LongInteger.prototype.div = function (value) {
            var unwrappedValue = LongInteger.unwrapInputValue(value);
            var result = this.internalValue.div(unwrappedValue);
            var newInstance = LongInteger.fromObject(result);
            return newInstance;
        };
        LongInteger.prototype.and = function (value) {
            var unwrappedValue = LongInteger.unwrapInputValue(value);
            var result = this.internalValue.and(unwrappedValue);
            var newInstance = LongInteger.fromObject(result);
            return newInstance;
        };
        LongInteger.prototype.equals = function (value) {
            var unwrappedValue = LongInteger.unwrapInputValue(value);
            var result = this.internalValue.equals(unwrappedValue);
            return result;
        };
        LongInteger.prototype.lessThan = function (value) {
            var unwrappedValue = LongInteger.unwrapInputValue(value);
            var result = this.internalValue.lessThan(unwrappedValue);
            return result;
        };
        LongInteger.prototype.lessThanOrEqual = function (value) {
            var unwrappedValue = LongInteger.unwrapInputValue(value);
            var result = this.internalValue.lessThanOrEqual(unwrappedValue);
            return result;
        };
        LongInteger.prototype.greaterThan = function (value) {
            var unwrappedValue = LongInteger.unwrapInputValue(value);
            var result = this.internalValue.greaterThan(unwrappedValue);
            return result;
        };
        LongInteger.prototype.greaterThanOrEqual = function (value) {
            var unwrappedValue = LongInteger.unwrapInputValue(value);
            var result = this.internalValue.greaterThanOrEqual(unwrappedValue);
            return result;
        };
        LongInteger.prototype.toNumber = function () {
            var result = this.internalValue.toNumber();
            return result;
        };
        LongInteger.prototype.toString = function () {
            var result = this.internalValue.toString();
            return result;
        };
        LongInteger.prototype.valueOf = function () {
            var result = this.internalValue.valueOf();
            return result;
        };
        LongInteger.defaultValue = LongInteger.fromObject(LongJS.ZERO);
        LongInteger.MIN_VALUE = LongInteger.fromObject(LongJS.MIN_VALUE);
        LongInteger.MAX_VALUE = LongInteger.fromObject(LongJS.MAX_VALUE);
        return LongInteger;
    }());
    exports.default = LongInteger;
});
//# sourceMappingURL=LongInteger.js.map;
